import { Component, OnInit, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ActionSheetController, AlertController, ModalController, ViewWillEnter, LoadingController } from '@ionic/angular';

import { UserService } from '../services/user.service';
import { SaleService } from '../services/sale.service';
import { Stylist } from '../models/stylist/stylist.model';
import { Sale } from '../models/sale/sale.model';
import { StylistPickerComponent } from '../components/stylist-picker/stylist-picker.component';
import { SaleSelectEvent } from '../components/sale-list/sale-list.component';
import { Utilities, DateRange } from '../utilities/utilities';
import { SaleCheckOutCallBackData } from './sale-checkout/sale-checkout.page';
import { List } from 'immutable';
import { AlertService } from '../utilities/alert.service';
import { ToastService } from '../utilities/toast.service';
import { Router } from '@angular/router';
import {SaleLookupPage} from './sales-shared/sale-lookup/sale-lookup.page';
import { DateRangeService } from '../services/date-range.service';
import { SalonService } from '../services/salon.service';
import { SaleBookingPickerPage } from './sales-shared/sale-booking-picker/sale-booking-picker.page';
import { UniversalSearchComponent } from 'src/app/components/universal-search/universal-search.component'; 
import { NavigationStateService } from '../services/navigation-state.service';
@Component({
  selector: 'app-sales',
  templateUrl: './sales.page.html',
  styleUrls: ['./sales.page.scss'],
})
export class SalesPage implements OnInit, ViewWillEnter {


  @ViewChild(StylistPickerComponent) stylistPickerComponent: StylistPickerComponent;

  public readOnlyStylistPicker: boolean;

  public isLoading: boolean = true;

  public stylist: Stylist;

  public completedSales: List<Sale>;

  public onHoldSales: List<Sale>;

  public errorOccurredWhileLoadingStylistPicker: boolean = false;

  public errorOccurredWhileLoadingSales: boolean = false;

  public activeSegment: string = 'completed';

  public startDate: Date;

  public endDate: Date;

  public isReadOnly: boolean = false;

  constructor (
              //private navCtrl: NavController, 
              private alertCtrl: AlertController,
              private modalCtrl: ModalController,
              private actionSheetCtrl: ActionSheetController,
              private saleService: SaleService,
              private changeDetectorRef: ChangeDetectorRef,
              private userService: UserService,
              private salonService: SalonService,
              // private googleAnalytics: GoogleAnalytics,
              //private loadingCtrl: LoadingController,
              private router: Router,
              private readonly alertService: AlertService,
              private loadingCtrl: LoadingController,
              private readonly toastService: ToastService,
              private readonly dateRangeService: DateRangeService,
              private navigationStateService: NavigationStateService) {
    this.isLoading = true;
    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.onStylistSelect(user.clone());
      if (user.isAdministrator() || user.getViewAllCalendars() === 1) {
        this.readOnlyStylistPicker = false;
      } else {
        this.readOnlyStylistPicker = true;
      }
    }

    this.completedSales = List([]);
    this.onHoldSales = List([]);
    this.activeSegment = 'completed';

    // const weekRange = Utilities.getThisWeekRange();
    // this.startDate = weekRange.start;
    // this.endDate = weekRange.end;
    this.startDate = this.dateRangeService.getStartDate();
    this.endDate = this.dateRangeService.getEndDate();
    if(!this.startDate || !this.endDate){
      const weekRange = Utilities.getThisWeekRange();
      this.startDate = weekRange.start;
      this.endDate = weekRange.end;
    }
  }


  public ionViewWillEnter() {
    this.reloadPage()
  }

  public ngOnInit () {
    this.isReadOnly = this.salonService.getIsReadOnly();
    // this.googleAnalytics.trackView('SaleManagerPage')
    //   .then(() => {
    //   })
    //   .catch(() => {
    //   });
  }

  public rangeChanged (dateRange: DateRange) {
    this.startDate = dateRange.start;
    this.endDate = dateRange.end;
    this.dateRangeService.setStartDate(this.startDate);
    this.dateRangeService.setEndDate(this.endDate);
    
    this.reloadPage();
  }

  public onStylistPickerInit (initResponse: {success: boolean, stylist: Stylist}) { 
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
    } else {
      this.isLoading = false;
      this.errorOccurredWhileLoadingStylistPicker = true;
      this.changeDetectorRef.markForCheck();
    }
  }

  public onStylistSelect (stylist: Stylist) {
    this.stylist = stylist;
    this.reloadPage();
  }

  public onTapToReload () {
    this.isLoading = true;

    if (this.errorOccurredWhileLoadingStylistPicker) {
      this.errorOccurredWhileLoadingStylistPicker = false;
      this.stylistPickerComponent.ngOnInit();
    } else if (this.errorOccurredWhileLoadingSales) {
      this.errorOccurredWhileLoadingSales = false;
      this.reloadPage();
    }
  }

  public reloadPage () {
    if (this.activeSegment === 'completed') {
      this.loadCompletedSales();
    } else {
      this.loadOnHoldSales();
    }
  }

  public loadCompletedSales () {
    this.isLoading = true;
    this.errorOccurredWhileLoadingSales = false;
    this.completedSales = List([]);

    let saleObservable = this.stylist.getID() !== 0 
      ? this.saleService.loadSales(this.stylist.getID(), Utilities.startOfTheDay(this.startDate), Utilities.endOfTheDay(this.endDate), List.of(1))
      : this.saleService.loadSalonSales(Utilities.startOfTheDay(this.startDate), Utilities.endOfTheDay(this.endDate), List.of(1), false);

    saleObservable
      .subscribe({
        next:(sales) => {
        this.completedSales = sales;
        this.changeDetectorRef.markForCheck();
        this.isLoading = false;
    
      },
      error:(e) => {
        this.isLoading = false;
        this.errorOccurredWhileLoadingSales = true;
        this.changeDetectorRef.markForCheck();
      }
    });
  }

  public loadOnHoldSales () {
    this.isLoading = true;
    this.errorOccurredWhileLoadingSales = false;
    this.onHoldSales = List([]);

    let saleObservable = this.stylist.getID() !== 0 
      ? this.saleService.loadSales(this.stylist.getID(), Utilities.startOfTheDay(this.startDate), Utilities.endOfTheDay(this.endDate), List.of(2))
      : this.saleService.loadSalonSales(Utilities.startOfTheDay(this.startDate), Utilities.endOfTheDay(this.endDate), List.of(2), false);
      
    saleObservable
      .subscribe({
        next:(sales) => {
        this.isLoading = false;
        this.onHoldSales = sales;
        this.changeDetectorRef.markForCheck();
    
      },
      error:(err) => {
        this.isLoading = false;
        this.errorOccurredWhileLoadingSales = true;
        this.changeDetectorRef.markForCheck();
      }
    });
  }

  public async createSale () {
    if (this.isReadOnly) {
      return;
    }

    const actionSheet = await this.actionSheetCtrl.create({
      buttons: [
        {
          text:'Pay for an appointment',
          handler: async() => {
            const modal =  await this.modalCtrl.create({component: SaleBookingPickerPage});
            modal.onWillDismiss().then((booking:any) => {
              if (booking.data) {
                this.saleService.createRawSaleFromABooking(booking.data)
                  .subscribe({
                    next:(sale: Sale) => {
                    this.showCheckOutPage(sale);
                  },
                  error:(err) => {
                    this.alertService.presentErrorAlert();
                  }
                  });
              }
            });
            await modal.present();
          }
        },
        {
          text: `Select a customer`,
          handler: async() => {
            const modal = await this.modalCtrl.create({component: UniversalSearchComponent})
            modal.onWillDismiss().then((data:any) => {
              if (data) {
                 // this.saleService.createRawSaleForClient(client)
                 this.saleService.createRawSaleForClient(data.data)
                  .subscribe({
                    next:(sale: Sale) => {
                    this.showCheckOutPage(sale);
                  },
                  error:(err) => {
                    this.alertService.presentErrorAlert();
                  }
                }); 
              }
            });
            await modal.present();
          }
        },
        {
          text: `Walk In`,
          handler: () => {
            this.saleService.createRawSaleForWalkInClient()
              .subscribe({
                next:(sale: Sale) => {
                this.showCheckOutPage(sale);
              },
              error:(err) => {
                this.alertService.presentErrorAlert();
              }
            });
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            
          }
        }
      ]
    });

    actionSheet.present();
  }

  public viewReceipt (event: SaleSelectEvent) {
    new Promise((resolve, reject) => {
    this.navigationStateService.setState({
      saleID: event.sale.id,
    });

    this.router.navigate(['./sales/sale-receipt/'+ event.sale.id])
    })
    .then((callBackData: SaleCheckOutCallBackData) => {

      if (callBackData.action === 'save') {

        if (callBackData.sale.status === 1) {

          if (callBackData.sale.isRefundSale()) {

            if (Utilities.isBefore(callBackData.sale.datetime, this.startDate) || Utilities.isAfter(callBackData.sale.datetime, this.endDate)) {
              return;
            }

            // this.completedSales = this.completedSales.unshift(callBackData.sale);
            this.loadCompletedSales();

          } else {

            // Sale Edit
            if (!Utilities.isEqual(callBackData.sale.datetime, event.sale.datetime)) {
              this.reloadPage();
              return;
            }

            // this.completedSales = this.completedSales.set(event.index, callBackData.sale);
            this.loadCompletedSales();
          }

        }

      } else if (callBackData.action === 'delete') {

        // Sale Delete
        // this.completedSales = this.completedSales.remove(event.index);
        this.loadCompletedSales();
      }

      // if (callBackData.viewReceipt) {
      //   this.viewReceipt({
      //     sale: callBackData.sale,
      //     index: 0
      //   });
      // }

      // this.changeDetectorRef.markForCheck();
    });
  }

  public showCheckOutPage (sale: Sale) {
    new Promise((resolve, reject) => {
      this.navigationStateService.setState({
        sale: sale,
      });
      this.router.navigate(['../sales/sale-checkout'])
    }).then((data: SaleCheckOutCallBackData) => {
      if (data.action === 'save') {
        if (data.sale.status === 1) {

          if (Utilities.isBefore(data.sale.datetime, this.startDate) || Utilities.isAfter(data.sale.datetime, this.endDate)) {
            return;
          }

          // Sale Created
          // this.completedSales = this.completedSales.unshift(data.sale);
          // this.changeDetectorRef.markForCheck();
          this.loadCompletedSales();
        } else {

          // ON HOLD
          if (this.activeSegment === 'on-hold') {
            this.loadOnHoldSales();
          }
          
        }
      }

    });
  }

  public editOnHoldSale (event: SaleSelectEvent) {
    new Promise(async (resolve, reject) => {
      /*const loader = this.loadingCtrl.create({
        spinner: 'crescent'
      });*/
          const loader = await this.loadingCtrl.create({
        spinner: 'crescent',
      });

      loader.present();
      this.saleService.loadSaleByID(event.sale.id)
        .subscribe({
          next:(sale: Sale) => {
            loader.dismiss().then(() => {
            this.navigationStateService.setState({
              sale: sale,
            });
          
            this.router.navigate(["../sales/sale-checkout"]);
          });
        },
        error:(err) => {
          loader.dismiss().then(async() => {
            const alert = await this.alertCtrl.create(Utilities.getDefaultErrorMessageConfig());
            alert.onDidDismiss().then(() => {
              //this.navCtrl.pop();
              this.router.navigateByUrl('./sales/sale-manager');
            });
            this.alertService.presentErrorAlert();
          });
        }
      });

    }).then((data: SaleCheckOutCallBackData) => {

      if (data.action === 'save') {
        if (data.sale.status === 1) {

          // Sale has been completed
          // this.onHoldSales = this.onHoldSales.remove(event.index);
          // this.changeDetectorRef.markForCheck();
          this.loadOnHoldSales();
        }
      } else if (data.action === 'delete') {
        // this.onHoldSales = this.onHoldSales.remove(event.index);;
        // this.changeDetectorRef.markForCheck();
        this.loadOnHoldSales();
      }
    });

  }

  public async openSearchLookUpPage () {
    const modal = await this.modalCtrl.create({component:SaleLookupPage});
    await modal.present();
  }

}
